import { render, staticRenderFns } from "./BackgroundColorPicker.vue?vue&type=template&id=4da4fe82&scoped=true&"
import script from "./BackgroundColorPicker.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColorPicker.vue?vue&type=style&index=0&id=4da4fe82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4fe82",
  null
  
)

export default component.exports